import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { title } from '~/util/site';
import { BEM } from '@feedfm/feed-util';
import { useQuery } from '@apollo/client';
import {
  ContentSourceDetailLoaderGetSource,
  ContentSourceDetailLoaderGetSourceVariables,
} from '~/graphqlTypes/ContentSourceDetailLoaderGetSource';
import { getGraphQLErrorMessagesUi } from '~/util/errors';
import { ContentSourceDetail, ContentSourceDetailProps } from './_ContentSourceDetail';
import queries from './ContentSourceDetailQueries.gql';

export interface ContentSourceDetailLoaderProps {
  className?: string;
}

export const ContentSourceDetailLoader: React.FC<ContentSourceDetailLoaderProps> = ( { className } ) => {
  const bem = new BEM( 'ops-catalog-sources-detail-loader', [] );
  const id = Number( location.pathname.split( '/' ).pop() );
  const [loadedProps, setLoadedProps] = useState<ContentSourceDetailProps | undefined>();
  const [error, setError] = useState<Error | undefined>();

  const {
    data,
    loading,
    error: loadingError,
  } = useQuery<ContentSourceDetailLoaderGetSource, ContentSourceDetailLoaderGetSourceVariables>(
    queries.ContentSourceDetailLoaderGetSource,
    { variables: { id } },
  );

  useEffect( () => {
    if ( data ) {
      if ( data.contentSourceById && data.contentSourceById.__typename === 'ContentSource' ) {
        setLoadedProps( { source: data.contentSourceById } );
      } else {
        setError( new Error( `Audio file source with ID #${id} could not be found.` ) );
      }
    } else if ( loadingError ) {
      setError( new Error( `Failed to load content source with ID #${id}.` ) );
    }
  }, [id, data, loadingError] );

  return (
    <article data-testid="ops-catalog-sources-detail-loader" className={ BEM.$( bem, className ) }>
      <Helmet>
        <title>{ title( `Catalog | Sources | ${'x'}` ) }</title>
      </Helmet>
      { loading && <p>Loading…</p> }
      { error && getGraphQLErrorMessagesUi( error ) }
      { loadedProps && <ContentSourceDetail { ...loadedProps } /> }
    </article>
  );
};
